import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import FinalizeTpClientInvoiceBulkItem from '../../../Domain/FinalizeTpClientInvoiceBulkItem';
import {
  checkFinalizeComment,
  checkJobsNoLongerReadyChoice,
  getFinalizeRequest,
  getJobsNoLongerReadyChoiceOptions,
} from '../../../Helpers/finalizeJobsNoLongerReadyHelper';

export default class FinalizeTpClientInvoiceBulkWindowDescription extends React.Component {
  static titleForEdit = 'Invoice Bulk Finalization';
  static finishButtonLabel = 'Finalize';
  static itemType = FinalizeTpClientInvoiceBulkItem;
  static serviceFunction = (editedItem) =>
    TpClientInvoiceService.FinalizeSelectedInvoice(
      getFinalizeRequest(editedItem),
      FinalizeTpClientInvoiceBulkWindowDescription.getSearchParameters(),
      FinalizeTpClientInvoiceBulkWindowDescription.getSelected(),
      FinalizeTpClientInvoiceBulkWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  // CD-5483: the number of the newest note request; a request that is no longer the newest leaves the note alone.
  static noteRequestCount = 0;

  // CD-5483: the note of the invoices typed so far, fetched once typing pauses. Every keystroke calls this, and only
  // the newest call sets the note, so a slow answer for earlier ids never replaces a newer one. Returns nothing: the
  // pop-up then takes over the note alone, never the ids typed since.
  static async loadApprovalNote(editedItem) {
    const request = ++FinalizeTpClientInvoiceBulkWindowDescription.noteRequestCount;
    await new Promise((resolve) => {
      setTimeout(resolve, 600);
    });
    if (request !== FinalizeTpClientInvoiceBulkWindowDescription.noteRequestCount) {
      return;
    }

    const note = /\d/.test(editedItem.IdListString ?? '')
      ? await TpClientInvoiceService.GetFinalizeApprovalNote(null, [], false, editedItem.IdListString)
      : '';

    if (request === FinalizeTpClientInvoiceBulkWindowDescription.noteRequestCount) {
      editedItem.EvaluatorPaymentApprovalNote = note;
    }
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IdListString',
          label: 'Invoice IDs (id1,id2,id3...)',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          onFieldChange: FinalizeTpClientInvoiceBulkWindowDescription.loadApprovalNote,
        },
        {
          // CD-5483: empty, and hidden, when no evaluator payment of the invoices would need supervisor approval.
          fieldName: 'EvaluatorPaymentApprovalNote',
          label: 'Supervisor approval',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.EvaluatorPaymentApprovalNote,
        },
        {
          fieldName: 'JobsNoLongerReadyChoice',
          label: 'Shops No Longer Ready For Invoicing *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: () => getJobsNoLongerReadyChoiceOptions(),
          validityChecker: checkJobsNoLongerReadyChoice,
          info: 'For every invoice holding shops that no longer pass the Ready for Invoicing rules: their status changed, or they were marked uninvoiceable.',
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: checkFinalizeComment,
        },
      ],
    },
  ];
}
